import React, { useState } from 'react';
import authService from '../services/auth_service';
import { Navigate } from 'react-router-dom';

const Protected = ({ children, allowedRoles }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(authService.isLoggedIn());
  const userData = authService.getUserDataFromLocalStorage()
  const userRole = userData.role;

  if (!isLoggedIn || !allowedRoles.includes(userRole)) {
    return <Navigate to={'/'} />;
  }

  return children;
};

export default Protected;
